module.exports = __webpack_public_path__ + "img/black-friday.881c7a28.svg";